var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('feed',{attrs:{"feed-list-uid":_vm.professional.feedList,"target-feed-lists-uid":[_vm.professional.feedList, _vm.space.feedList],"filter-subscriptions-uid":_vm.selectedSubscriptionsUid}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }